<template>
	<div class="modal">
		<FormKit v-slot="{ state: { valid } }" type="form" :actions="false">
			<div class="row">
				<div class="col-md-12 end-sm end-md end-lg">
					<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
				</div>
			</div>
			<div class="row margin-b40">
				<div class="col-md-12 w-full">
					<p class="textGrey textLg textCenter">Create new user</p>
				</div>
			</div>

			<div class="row margin-b30">
				<div class="col-xs-12 col-sm-12 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4">
					<div class="card formPanel">
						<div class="content">
							<div class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="username">Email Address</label>
										<FormKit
											v-model="email"
											type="text"
											class="form-control"
											placeholder="Email Address"
											name="Email Address"
											:validation="[
												['required'],
												['matches', /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/]
											]"
											:validation-messages="{
												matches: 'Valid email address required'
											}"
											validation-visibility="live"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="password">Password</label>
										<FormKit
											v-model="password"
											type="password"
											autocomplete="new-password"
											class="form-control"
											placeholder="Password"
											name="password"
											:validation="[
												['required'],
												[
													'matches',
													/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&-]{8,}$/
												]
											]"
											:validation-messages="{
												matches: 'Does not meet minimum password criteria (see below)'
											}"
											validation-visibility="live"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="confirmPassword">Confirm Password</label>
										<FormKit
											v-model="confirmPassword"
											type="password"
											autocomplete="new-password"
											class="form-control"
											placeholder="Confirm Password"
											name="password_confirm"
											validation-label="Confirm Password"
											:validation="[
												['required'],
												['confirm'],
												[
													'matches',
													/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&-]{8,}$/
												]
											]"
											:validation-messages="{
												matches: 'Does not meet minimum password criteria (see below)',
												confirm: 'Passwords do not match'
											}"
											validation-visibility="live"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="userType">User Type</label>
										<select v-model="userType">
											<option :value="null">-- Select User Type --</option>
											<option v-if="$global.hasUserRole(userRoles, 'admin')" value="reseller">
												Reseller
											</option>
											<option
												v-if="
													$global.hasUserRole(userRoles, 'admin') ||
													$global.hasUserRole(userRoles, 'reseller')
												"
												value="tenant"
											>
												Tenant
											</option>
											<option value="account">Account</option>
										</select>
									</div>
								</div>
							</div>
							<div v-if="userType === 'tenant'" class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="tenant">Tenant</label>
										<select id="tenant" v-model="tenantId">
											<option :value="null">-- Select Tenant --</option>
											<option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
												{{ tenant.companyName }}
											</option>
										</select>
									</div>
								</div>
							</div>
							<div v-if="userType === 'account'" class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="account">Account</label>
										<select id="account" v-model="accountId">
											<option :value="null">-- Select Account --</option>
											<option
												v-for="account in accounts.sort((a, b) =>
													a.name.toLowerCase().localeCompare(b.name.toLowerCase())
												)"
												:key="account.id"
												:value="account.id"
											>
												{{ account.name }}
											</option>
										</select>
									</div>
								</div>
							</div>
							<div v-if="userType === 'reseller'" class="row">
								<div class="col-md-12">
									<div class="formGroup">
										<label for="reseller">Reseller</label>
										<select id="reseller" v-model="resellerId">
											<option :value="null">-- Select Reseller --</option>
											<option
												v-for="reseller in resellers"
												:key="reseller.id"
												:value="reseller.id"
											>
												{{ reseller.companyName }}
											</option>
										</select>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 mt-2">
									<p class="textGrey textXsml">
										Password must be at least 8 characters long and contain at least one uppercase
										letter, one lowercase letter, one number and one special character.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row margin-b20">
				<div class="col-md-12 mx-auto">
					<ul class="stepBtns">
						<li><a :disabled="!valid" class="jmiBtn btnLg green" @click="save()">Create</a></li>
						<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
					</ul>
				</div>
			</div>
		</FormKit>
	</div>
</template>

<script>
import usersApi from '@/scripts/users/users.api'
import tenantsApi from '@/scripts/tenants/tenants.api'
import accountsApi from '@/scripts/accounts/accounts.api'
import resellersApi from '@/scripts/resellers/resellers.api'

export default {
	inject: ['user', 'userRoles'],

	data() {
		return {
			email: '',
			password: '',
			confirmPassword: '',
			userType: null,
			tenantId: null,
			accountId: null,
			resellerId: null,
			tenants: [],
			accounts: [],
			resellers: []
		}
	},

	mounted() {
		document.addEventListener('keyup', this.onKeyUp)

		if (this.userRoles?.includes('admin')) {
			resellersApi
				.getAll()
				.then((result) => {
					this.resellers = result.data.results
				})
				.catch((err) => {
					console.log(err)
				})
		}

		if (this.userRoles?.includes('reseller') || this.userRoles?.includes('admin')) {
			tenantsApi
				.getAll()
				.then((result) => {
					this.tenants = result.data.results
				})
				.catch((err) => {
					console.log(err)
				})
		}

		if (
			this.userRoles?.includes('tenant') ||
			this.userRoles?.includes('admin') ||
			this.userRoles?.includes('reseller')
		) {
			accountsApi
				.getAll({ limit: 2500 })
				.then((result) => {
					this.accounts = result.data.results
				})
				.catch((err) => {
					console.log(err)
				})
		}
	},

	beforeUnmount() {
		document.removeEventListener('keyup', this.onKeyUp)
	},

	methods: {
		close() {
			this.$emit('close')
		},
		save() {
			if (!this.valid) return

			let user = {
				email: this.email,
				password: this.password
			}

			switch (this.userType) {
				case 'tenant':
					user.tenantId = this.tenantId
					break
				case 'account':
					user.accountId = this.accountId
					break
				case 'reseller':
					user.resellerId = this.resellerId
					break
			}

			usersApi
				.signup(user)
				.then((result) => {
					this.$emit('close')
				})
				.catch((err) => {
					console.log(err)
					this.$swal({
						title: 'Error',
						icon: 'error',
						text: err.error || err.message,
						confirmButtonText: 'Try Again'
					})
				})
		},
		onKeyUp(event) {
			if (event.key == 'Escape') this.$emit('close')
		}
	}
}
</script>
